import useGoBack from 'utilities/navigation/back'
import { Field, Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import AddNewIcon from 'assets/images/loans/managementAddNew.svg'
import CustomDatePicker from 'components/datePicker'
import Num2persian from 'utilities/helper/num2Persian'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import FeeModal from 'components/modals/feeModal'
import { Schema } from '../addNewLoan/utils'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import { toast } from 'react-toastify'
import { toggleAddNewLoan, toggleEditLoan } from 'store/redux/moneyPoolBox'
interface ILoan {
    id: number
    date?: string
    amount: string
    number: string
    tag?: string
    repayment_amount: string
    fee: string
    feeType: string
    selectedFeeType: string
}
export default function EditNewLoan() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [isOpenFeeModal, setIsOpenFeeModal] = useState<boolean>(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const goBack = useGoBack()
    const { state } = useLocation()
    const [oldLoan, setOldLoan] = useState<{
        id: number
        date?: string
        amount: string
        number: string
        tag?: string
        repayment_amount: string
        fee: string
        feeType: string
        selectedFeeType: string
    }>()
    const [selectedFee, setSelectedFee] = useState<number | undefined>()
    const [selectedFeeType, setSelectedFeeType] = useState<string>('percentage')
    useEffect(() => {
        if (store.loans.length > 0) {
            const realLoan = store.loans.find((item) => item.id === state.id)
            if (realLoan) {
                setOldLoan(realLoan)
                setSelectedFee(
                    realLoan && realLoan?.fee !== undefined
                        ? Number(realLoan?.fee)
                        : undefined
                )
                setSelectedFeeType(
                    realLoan && realLoan.selectedFeeType
                        ? realLoan.selectedFeeType
                        : 'percentage'
                )
            } else {
                toast.error('صفحه مورد نظر یافت نشد')
                navigate(-1)
            }
        }
    }, [store])
    return (
        <>
            <Formik
                initialValues={{
                    date: oldLoan && oldLoan.date ? oldLoan.date : '',
                    amount: oldLoan && oldLoan.amount ? oldLoan.amount : '',
                    number: oldLoan && oldLoan.number ? oldLoan.number : '',
                    tag: oldLoan && oldLoan.tag ? oldLoan.tag : '',
                    repayment_amount:
                        oldLoan && oldLoan.repayment_amount
                            ? oldLoan.repayment_amount
                            : '',
                    fee_type: oldLoan && oldLoan.feeType ? oldLoan.feeType : '',
                }}
                enableReinitialize
                validationSchema={Schema}
                onSubmit={(values) => {
                    if (Number(values.amount) >= 5000) {
                        if (values.fee_type !== '') {
                            if (selectedFee !== undefined && selectedFeeType) {
                                if (
                                    Number(values.repayment_amount) <
                                    Number(values.number)
                                ) {
                                    const payload: IAddBoxNewLoanPayload = {
                                        id:
                                            oldLoan && oldLoan?.id
                                                ? oldLoan?.id
                                                : 0,
                                        ...(values.date !== '' && {
                                            date: values.date,
                                        }),
                                        amount: values.amount,
                                        number: values?.number,
                                        tag: values.tag,
                                        repayment_amount:
                                            values.repayment_amount,
                                        fee: String(selectedFee),
                                        feeType: values.fee_type,
                                        selectedFeeType: selectedFeeType,
                                    }
                                    dispatch(toggleEditLoan(payload))
                                    toast.success('وام شما باموفقیت ویرایش شد')
                                    navigate(-1)
                                } else {
                                    toast.error(
                                        'تعداد اقساط پرداخت شده نمی تواند از تعداد کل افساز بیشتر باشد'
                                    )
                                }
                            } else {
                                toast.error('کارمزد را وارد کنید')
                            }
                        } else {
                            toast.error('نحوه دریافت کارمزد را وارد کنید')
                        }
                    } else {
                        toast.error(
                            'مبلغ وام نمی تواند کمتر از 5000 تومان باشد'
                        )
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen text-sm ">
                            <div className=" grow-0">
                                <Header title="اعطای وام" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white  mt-14 rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className=" text-center mt-4">
                                        <img
                                            src={AddNewIcon}
                                            alt="add-loan"
                                            className=" absolute right-[35%] md:right-[40%] lg:right-[40%] -top-14"
                                        />
                                    </div>
                                    <div
                                        dir="rtl"
                                        className="border-b border-dashed border-gray-1"
                                    >
                                        <>
                                            <CustomDatePicker
                                                setValue={(e: string) => {
                                                    setFieldValue('date', e)
                                                }}
                                                name={'date'}
                                                title="تاریخ اعطای وام"
                                                placeHolder="تاریخ اعطای وام"
                                                value={values.date}
                                            />
                                        </>
                                    </div>
                                    <div className="  w-full text-center">
                                        <Field
                                            type="text"
                                            inputMode="numeric"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            placeholder="مبلغ وام (تومان)"
                                            name="amount"
                                            min={0}
                                        />
                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}

                                        <div className=" w-full text-center">
                                            <Field
                                                type="text"
                                                inputMode="numeric"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3  "
                                                name="number"
                                                placeholder="تعداد اقساط "
                                                min={0}
                                            />
                                            {errors.number &&
                                                touched.number && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {errors.number}
                                                    </p>
                                                )}
                                        </div>
                                        <div
                                            onClick={() =>
                                                setIsOpenFeeModal(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedFee !== undefined
                                                ? `${selectedFee} ${
                                                      selectedFeeType ===
                                                      'percentage'
                                                          ? 'درصد'
                                                          : 'تومان'
                                                  }`
                                                : 'میزان کارمزد'}
                                        </div>
                                        <Field
                                            name="fee_type"
                                            as="select"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                        >
                                            <option className="text-gray-1">
                                                نحوه دریافت کارمزد
                                            </option>
                                            <option value="lip_ma">
                                                افزودن به هر قسط
                                            </option>
                                            <option value="lip_pr">
                                                کسر از مبلغ وام
                                            </option>
                                        </Field>
                                        <div className=" w-full text-center">
                                            <Field
                                                type="text"
                                                inputMode="numeric"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-[#000000]  "
                                                name="repayment_amount"
                                                placeholder="تعداد اقساط پرداخت شده"
                                                min={0}
                                            />
                                            {errors.repayment_amount &&
                                                touched.repayment_amount && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {
                                                            errors.repayment_amount
                                                        }
                                                    </p>
                                                )}
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات(اختیاری)"
                                        />
                                        {errors.tag && touched.tag && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.tag}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                قبت وام
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 "
                                onClick={goBack}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <FeeModal
                show={isOpenFeeModal}
                onHide={() => setIsOpenFeeModal(false)}
                setSelectedFee={setSelectedFee}
                setSelectedFeeType={setSelectedFeeType}
            />
        </>
    )
}
